export const servicesData = [
    // --- AI Services (positioned first) ---
    {
        id: 1,
        title: 'AI Data Collection',
        description: 'Fuel your AI and ML models with high-quality, custom-collected datasets — images, video, speech, text, and survey data gathered at scale from diverse global participants.',
        icon: 'BrainCircuit',
        features: ['Image Data Collection', 'Video Data Collection', 'Speech & Audio Collection', 'Text Dataset Creation', 'Survey Data Collection', 'Custom Dataset Projects'],
        value: 'ai-data-collection'
    },
    {
        id: 2,
        title: 'Data Annotation & Labeling',
        description: 'Transform raw data into training-ready assets with precise annotation across image, video, text, and audio modalities for computer vision and NLP applications.',
        icon: 'Tags',
        features: ['Bounding Box Annotation', 'Polygon & Segmentation', 'NLP Labeling', 'Audio Transcription', 'Sentiment Classification', 'Keypoint & Landmark Annotation'],
        value: 'data-annotation'
    },
    {
        id: 3,
        title: 'AI Dataset Validation & Recruitment',
        description: 'Ensure your datasets meet production quality standards with human review, compliance checks, and targeted participant sourcing across global demographics.',
        icon: 'ShieldCheck',
        features: ['Participant Recruitment', 'Data Quality Assurance', 'Dataset Validation', 'Compliance Checks', 'Metadata Verification', 'Human Review Processes'],
        value: 'ai-dataset-validation'
    },

    // --- Digital Marketing Services ---
    {
        id: 4,
        title: 'Website Development',
        description: 'Create stunning, responsive websites that convert visitors into customers with modern design and functionality.',
        icon: 'Monitor',
        features: ['Custom Web Development', 'Responsive Design', 'E-commerce Solutions', 'CMS Integration'],
        value: 'web-development'
    },
    {
        id: 5,
        title: 'SEO & Content Marketing',
        description: 'Boost your search rankings and drive organic traffic with strategic SEO and compelling content.',
        icon: 'Search',
        features: ['Keyword Research', 'On-Page SEO', 'Content Strategy', 'Link Building'],
        value: 'seo'
    },
    {
        id: 6,
        title: 'Social Media Marketing (SMO)',
        description: 'Build engaged communities and amplify your brand across all social media platforms globally.',
        icon: 'Share2',
        features: ['Social Strategy', 'Content Creation', 'Community Management', 'Influencer Marketing'],
        value: 'social-media'
    },
    {
        id: 7,
        title: 'Google Ads & PPC',
        description: 'Maximize ROI with expertly managed Google Ads campaigns and pay-per-click advertising.',
        icon: 'Target',
        features: ['Campaign Setup', 'Keyword Optimization', 'Ad Copy Creation', 'Conversion Tracking'],
        value: 'google-ads'
    },
    {
        id: 8,
        title: 'Meta Ads (Facebook & Instagram)',
        description: 'Reach your target audience with highly effective Meta advertising campaigns across Facebook and Instagram.',
        icon: 'Smartphone',
        features: ['Audience Targeting', 'Creative Design', 'Campaign Optimization', 'Performance Analytics'],
        value: 'meta-ads'
    },
    {
        id: 9,
        title: 'Email & Domain Migration',
        description: 'Seamlessly migrate your email systems and domains with zero downtime and complete data integrity.',
        icon: 'Mail',
        features: ['Email Migration', 'Domain Transfer', 'DNS Management', 'Technical Support'],
        value: 'migration'
    }
];
